module.exports = __webpack_public_path__ + "media/20.d1173d7f.mp3";